<template>
	<div class="knowledge-repository-container">
		<form class="knowledge-repository-head" action="javascript:;">
			<input class="text" type="text" v-model="searchText" placeholder="请输入关键字">
			<a class="icon icon-sousuo2 btn" @click="clickSearch"></a>
		</form>
		<div class="knowledge-repository-list">
			<template v-if="list.length">
				<dl v-for="obj in list">
					<dt>{{ obj.name }}</dt>
					<dd v-for="rObj in obj.rules">
						<el-popover v-if="rObj.answer" placement="left" width="300" trigger="hover" :content="rObj.answer">
							<a class="btn" href="javascript:;" title="点击发送" slot="reference" @click="addToSendContent(rObj.answer)">回复</a>
						</el-popover>
						<el-popover placement="left" width="300" trigger="hover" :content="rObj.title + ': ' + rObj.content">
							<label slot="reference">{{ rObj.title }}: {{ rObj.content }}</label>
						</el-popover>
					</dd>
				</dl>
			</template>
			<p v-else class="shift" style="margin: 0 10px">没有数据</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'aiStorTpl',
	data () {
		return {
			searchText: '',
			list: []
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		}
	},
	watch: {
		currentShop: {
			deep: true,
			handler (now, old) {
				var self = this;

				if (now.id == old.id || !now.id) return;
				self.searchAI();
			}
		}
	},
	methods: {
		// 点击查询按钮
		clickSearch () {
			var self = this;

			if (!self.searchText.trim()) return;
			self.searchAI();
		},

		// 查询知识库
		searchAI () {
			var self = this,
				url = API_ROOT.aiUrl + '/api/v1/rule/shop/' + self.currentShop.id,
				data = {
					searchStr: self.searchText
				};

			self.$axios.get(url, data).then(result => {
				self.list = result;

			}, response => {
				self.list = [];
				console.log('查询知识库数据失败，错误码(' + response + ')');
			})
		},

		// 点击回复添加到发送框
		addToSendContent(content) {
			var self = this;

			if (!self.$store.state.conversationList.length) return;
			self.$store.commit('changeSendContent', content);
			document.getElementsByClassName('ima_textarea')[0].focus();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/aiStorTpl.vue